export default __webpack_public_path__ + "static/centralized-data-06b9e51e3aff8887c0a3d40aa92d70e1.png";